module.exports = ".table-card-header-bg {\r\n    background-color: #344d6e;\r\n}\r\n\r\n.table td, .table th {\r\n    border: none!important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/table-card/table-card.component.css
// module id = ./src/app/shared/components/table-card/table-card.component.css
// module chunks = main